import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { roleQuery } from '@/features/admin/admin-api';
import { adminErrorMessage } from '@/features/admin/admin-errors';
import { requirePermission } from '@/features/admin/guard';
import { RoleEditor } from '@/features/admin/roles/role-editor';
import { adminTexts } from '@/features/admin/texts';
import { FormError } from '@/features/auth/form-error';

export const Route = createFileRoute('/_app/admin/roles/$roleId')({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'admin.roles');
  },
  component: RolePage,
});

function RolePage() {
  const { roleId } = Route.useParams();
  const role = useQuery(roleQuery(roleId));
  if (role.isPending) return <p className="text-muted-foreground">{adminTexts.common.loading}</p>;
  if (role.isError) return <FormError message={adminErrorMessage(role.error)} />;
  return <RoleEditor key={role.data.id} role={role.data} />;
}
